import { 
    Clock, CheckSquare, Package, Truck, 
    CheckCircle, XCircle, RefreshCcw, 
    EyeOff, CalendarDays, Archive, ShoppingCart, AlertCircle, XOctagon 
} from 'lucide-react';

// ==========================================
// TRẠNG THÁI SẢN PHẨM (PRODUCT STATUS)
// ==========================================
export const PRODUCT_STATUS = {
    HIDDEN: 0,
    COMING_SOON: 1,
    IN_STOCK: 2,
    PRE_ORDER: 3,
    OUT_OF_STOCK: 4,
    DISCONTINUED: 5
};

export const PRODUCT_STATUS_CONFIG = {
    [PRODUCT_STATUS.HIDDEN]:       { text: 'Đang ẩn',           color: 'text-gray-500',   bg: 'bg-gray-100',   border: 'border-gray-200',   Icon: EyeOff },
    [PRODUCT_STATUS.COMING_SOON]:  { text: 'Hàng sắp về',       color: 'text-blue-600',   bg: 'bg-blue-100',   border: 'border-blue-200',   Icon: CalendarDays },
    [PRODUCT_STATUS.IN_STOCK]:     { text: 'Sẵn hàng',          color: 'text-green-600',  bg: 'bg-green-100',  border: 'border-green-200',  Icon: Archive },
    [PRODUCT_STATUS.PRE_ORDER]:    { text: 'Có hàng/Đặt hàng',  color: 'text-green-600',  bg: 'bg-green-100',   border: 'border-green-200',   Icon: ShoppingCart },
    [PRODUCT_STATUS.OUT_OF_STOCK]: { text: 'Hết hàng',          color: 'text-amber-600',  bg: 'bg-amber-100',  border: 'border-amber-200',  Icon: AlertCircle },
    [PRODUCT_STATUS.DISCONTINUED]: { text: 'Ngừng bán',         color: 'text-red-600',    bg: 'bg-red-100',    border: 'border-red-200',    Icon: XOctagon },
};

// ==========================================
// TRẠNG THÁI ĐƠN HÀNG (ORDER STATUS)
// ==========================================
export const ORDER_STATUS = {
    PENDING: 0,
    CONFIRMED: 1,
    IN_WAREHOUSE: 2,
    SHIPPING: 3,
    DELIVERED: 4,
    CANCELLED: 5,
    RETURNED: 6
};

export const ORDER_STATUS_CONFIG = {
    [ORDER_STATUS.PENDING]:      { 
        text: 'Chờ xác nhận', 
        color: 'text-red-600 font-extrabold',  
        bg: 'bg-red-50 border-2 border-red-400 animate-pulse shadow-md', 
        Icon: Clock 
    },
    [ORDER_STATUS.CONFIRMED]:    { text: 'Đã xác nhận',   color: 'text-yellow-700', bg: 'bg-yellow-100', Icon: CheckSquare },
    [ORDER_STATUS.IN_WAREHOUSE]: { text: 'Hàng đã về kho',color: 'text-purple-700', bg: 'bg-purple-100', Icon: Package },
    [ORDER_STATUS.SHIPPING]:     { text: 'Đang giao hàng',color: 'text-blue-700',   bg: 'bg-blue-100',   Icon: Truck },
    [ORDER_STATUS.DELIVERED]:    { text: 'Giao thành công',color: 'text-green-700', bg: 'bg-green-100',  Icon: CheckCircle },
    [ORDER_STATUS.CANCELLED]:    { text: 'Đã hủy',        color: 'text-red-700',    bg: 'bg-red-100',    Icon: XCircle },
    [ORDER_STATUS.RETURNED]:     { text: 'Đổi trả hàng',  color: 'text-orange-700', bg: 'bg-orange-100', Icon: RefreshCcw },
};